<template>
	<div>
		<div class="report-layout__location">
			<div class="level" :class="{ 'is-marginless_old': moveChartIcons }">
				<div class="level-left">
					<h3 v-if="heading" class="title is-4 map-title" v-text="heading" />
				</div>
				<div class="level-right">
					<a
						v-if="showDownload"
						class="button map-title is-small gtm-download-excel level-item"
						:href="downloadURL"
						target="_blank"
					>
						<dc-icon icon="download" />
						<span>{{ downloadLabel }}</span>
					</a>
				</div>
			</div>
			<gmap-map
				ref="gmap"
				:center="center"
				:zoom="10"
				map-type-id="roadmap"
				:options="mapOptions"
				class="locations-map"
				:class="{ 'no-pins': !hasLocations }"
			>
				<gmap-marker
					v-for="location in locations"
					:key="location.id"
					:position="location"
					:title="location.title"
				></gmap-marker>
			</gmap-map>
		</div>
	</div>
</template>

<script>
export default {
	name: "MapLayoutWidget",
	props: {
		downloadsource: {
			type: String,
			default: () => null
		}
	},
	data() {
		return {
			map: null,
			heatmapbuilt: false,
			locations: [],
			heatsource: []
		};
	},
	computed: {
		heading() {
			return this.data.title;
		},
		center() {
			return {
				lat: -37.85217397,
				lng: 145.0348044
			};
		},
		mapOptions() {
			// options.fullscreenControl = true;
			return options;
		},
		mylocations() {
			return [];
		},
		showDownload() {
			return this.downloadsource !== null;
		},
		downloadURL() {
			return this.downloadsource;
		},
		downloadLabel() {
			return this.data.downloadlabel !== undefined
				? this.data.downloadlabel
				: "Download";
		},
		moveChartIcons() {
			return this.data.spacing && this.data.spacing >= 8;
		},
		hasLocations() {
			return this.locations && this.locations.length;
		}
	},
	watch: {
		async source(path) {
			await this.fetchData(path);
			this.fitBounds();
		}
	},
	async mounted() {
		if (this.source) {
			await this.fetchData(this.source);
		}

		this.$refs.gmap.$mapPromise.then((map) => {
			this.map = map;
			this.fitBounds();
		});
	},
	methods: {
		async fetchData() {
			this.isFetching = true;
			this.locations = [];
			this.label = "Loading";

			if (!this.isValid(this.source)) {
				this.isFetching = false;
				return;
			}

			await this.fetchSource(this.source).then(
				(response) => {
					this.locations = response;
					this.isFetching = false;
				},
				() => {
					this.label = this.errorMessage;
					this.isFetching = false;
				}
			);
		},
		fitBounds() {
			const bounds = new window.google.maps.LatLngBounds();
			if (this.hasLocations) {
				this.locations.forEach((marker) => {
					bounds.extend(new window.google.maps.LatLng(marker.lat, marker.lng));
				});
				this.map.fitBounds(bounds);
			}
		},
		dataURItoBlob(dataURI) {
			// convert base64 to raw binary data held in a string
			// doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
			var byteString = atob(dataURI.split(",")[1]);

			// separate out the mime component
			var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

			// write the bytes of the string to an ArrayBuffer
			var ab = new ArrayBuffer(byteString.length);

			// create a view into the buffer
			var ia = new Uint8Array(ab);

			// set the bytes of the buffer to the correct values
			for (var i = 0; i < byteString.length; i++) {
				ia[i] = byteString.charCodeAt(i);
			}

			// write the ArrayBuffer to a blob, and you're done
			var blob = new Blob([ab], { type: mimeString });
			return blob;
		}
	}
};
</script>

<style lang="scss" scoped>
.report-layout {
	&__location {
		margin-top: 2.5em;
	}
}

.locations-map {
	width: 100%;
	height: 400px;
	position: relative;

	&.no-pins {
		&:before {
			content: "There is no data to display";
			color: white;
			position: absolute;
			text-align: center;
			z-index: 3;
			left: 0;
			right: 0;
			margin-top: 14.5%;
			font-size: 1.4rem;
			font-weight: 600;
		}

		&:after {
			content: " ";
			position: absolute;
			background-color: rgba(0, 0, 0, 0.5);
			left: 0;
			right: 0;
			top: 0;
			bottom: 0;
		}
	}
}
</style>
